import { Directive, inject, Input } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { APP_CONFIG, ClickActionEvent, ENV_CONFIG, EXT_URL_CONFIG } from '@bn/primitives';
import { BnToastrService } from '@bn/shared/toastr';

import { ModalState } from '../models/modal-state.model';

@Directive()
export abstract class AbstractDialogDirective {
  protected readonly extUrlConfig = inject(EXT_URL_CONFIG);
  protected readonly appConfig = inject(APP_CONFIG);
  protected readonly envConfig = inject(ENV_CONFIG);

  @Input()
  public set dataIn(data: ModalState) {
    this.data = data;

    this.onDataInit?.();
  }

  @Input()
  public set dataOut(data: ModalState) {
    this.data = data;
    this.onDataInit?.();
  }

  public data: ModalState = {};
  public readonly buttons?: ModalState['buttons'] = {};
  public readonly title: ModalState['title'] = 'Just Another Modal With No Bunny inside';
  protected readonly toastr = inject(BnToastrService);
  readonly onAction = new Subject<ClickActionEvent>();
  protected readonly callbacks: ModalState['callbacks'] = {};

  // Optional to implement
  public onExampleCallback?(event: Event): void;
  /** On every data update this is called, set variables with data inside this method */
  protected onDataInit?(): void;

  /** Parent hooks to this observable, to actually close the Dialog, child send event + data via this */
  protected getOnAction(): Observable<ClickActionEvent> {
    return this.onAction.asObservable();
  }
}
